import AbstractService from '@/services/abstractService'

class ProjectService extends AbstractService {
    endpoint = 'projects'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }

    project(id) {
      return this.http.get(`${this.endpoint}/${id}`, { params: { dashboard: true } })
    }

    attributes() {
      return this.http.get('project/attributes', { params: { dashboard: true } })
    }

    post(data) {
      // define append form
      const formData = new FormData()
      for (const key in data) {
        if (key === 'initialSiteImages') {
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.post(this.endpoint, formData)
    }

    put(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()

      for (const key in data) {
        if (key === 'uploaded') {
          console.log(data[key])
          if (data[key].length === 0) formData.append(`${key}[]`, [])
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else if (key === 'remained') {
          if (data[key].length === 0) formData.append(`${key}[]`, [])
          for (const index in data[key]) {
            formData.append(`${key}[${index}]`, data[key][index])
          }
        } else if (data[key]) {
          formData.append(key, data[key])
        }
      }
      return this.http.put(`${this.endpoint}/${data.id}`, formData)
    }

    delete(data) {
      console.log('data', data)
      return this.http.delete(`${this.endpoint}/${data}`)
    }

    contract(id) {
      return this.http.get(`${this.endpoint}/${id}/contracts`, { params: { dashboard: true } })
    }

    createContract(projectId, data) {
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`${this.endpoint}/${projectId}/contracts`, formData)
    }

    updateContract(projectId, contractId, data) {
      const formData = new FormData()
      for (const key in data) {
        if (data[key] === null) {
          formData.append(key, '')
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.put(`${this.endpoint}/${projectId}/contracts/${contractId}`, formData)
    }

    getOwnerships(contractId) {
      return this.http.get(`contracts/${contractId}/clients`, { params: { dashboard: true } })
    }

    changeOwnerships(contractId, ownerId, data) {
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`contracts/${contractId}/owner/${ownerId}`, formData)
    }

    changeContractStatus(projectId, contractId) {

        return this.http.put(`${this.endpoint}/${projectId}/contracts/${contractId}/status`)
    }
}

const Service = new ProjectService()

export default Service
